// https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name
// Forbidden prefixes: Proxy-, Sec-
const forbiddenKeys = [
  'accept-charset',
  'accept-encoding',
  'access-control-request-headers',
  'access-control-request-method',
  'connection',
  'content-length',
  'cookie',
  'date',
  'dnt',
  'expect',
  'host',
  'keep-alive',
  'origin',
  'permissions-policy',
  'referer',
  'te',
  'trailer',
  'transfer-encoding',
  'upgrade',
  'via',
];

export const isForbiddenHeader = (key: string): boolean => {
  // per http specification header keys are case-insensitive
  const loweredKey = key.toLowerCase();
  const prefix = loweredKey.split('-')[0];
  const hasForbiddenPrefix = prefix === 'proxy' || prefix === 'sec';
  return forbiddenKeys.includes(loweredKey) || hasForbiddenPrefix;
};

export const hasForbiddenCharForHeader = (key: string): boolean => {
  return /[^a-zA-Z0-9_-]/i.test(key);
};
